/**
 * Render a EJS-Template
 *
 * Examples:
 * ```
 * // render the file "user.ejs"
 * const html = S.ejs.render('user', {
 *     name: 'Max Mustermann',
 *     group: 'User',
 *     age: 28,
 * });
 * ```
 */

S.ejs = {
    cache: {},

    /**
     * Render a template
     *
     * @param {string} name
     * @param {Object|Array} data
     * @returns {string}
     */
    render(name, data)
    {
        if (typeof this.cache[name] !== 'function')
        {
            console.warn('Template "' + name + '" could not be found.');

            return '';
        }

        const template = this.cache[name].bind(this);

        return template(data);
    },

    /**
     * Escapes HTML entities
     *
     * @param {string} text
     * @returns {string}
     */
    escape(text)
    {
        const entities = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '\'': '&apos;',
            '"': '&quot;',
        };

        return String(text).replace(/[&<>'"]/g, (char) =>
        {
            return entities[char] || char;
        });
    },
};
